// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/primevue/resources/primevue.min.css
// module id = jhi7
// module chunks = 38